import React, {FC} from 'react';

/** 이용 약관 한국어 본문 (i18n: 셸 컴포넌트가 언어별 콘텐츠 컴포넌트를 선택하며, 클래스명은 TermsOfUse__* BEM 블록을 재사용). 2026-09-17 AI 번역, 법률 문구는 비즈니스 검토 대기 */
const KoContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">시행일: August 28, 2026</p>
      <p className="v3-doc-meta">최종 업데이트: August 28, 2026</p>
      <p>Xiangji가 제공하는 제품 및 서비스를 이용해 주셔서 감사합니다!</p>
      <p>
        본 《Xiangji 사용자 서비스 이용 약관》(이하 “본 약관”)은 귀하와{' '}
        <strong>[Xiangji의 실제 운영 주체의 정식 명칭]</strong>(이하 “Xiangji” 또는 “당사”) 간에 Xiangji의 관련 제품 및
        서비스의 등록, 로그인 및 이용에 관하여 체결되는 계약입니다.
      </p>
      <p>
        Xiangji는 주로 크로스보더 이커머스 및 기타 비즈니스 사용자에게 AI 기반 시각 콘텐츠 처리 및 제작 서비스를
        제공하며, 여기에는 이미지 번역, 이미지 편집, 이미지 생성, 상품 장면 이미지 생성, 상품 모델 이미지 생성, 상품
        상세 이미지 세트 생성, 상품 대표 이미지 및 보조 이미지 생성, 마케팅 소재 생성 등 기타 관련 서비스가 포함되나
        이에 국한되지 않습니다.
      </p>
      <p>
        <strong>
          Xiangji 서비스를 이용하기 전에 본 약관을 주의 깊게 읽고 충분히 이해해 주시기 바라며, 특히 면책 조항, 책임
          제한, 사용자 콘텐츠 및 지식재산권, AI 생성 콘텐츠, 서비스 변경, 계정 관리, 법적 책임 및 분쟁 해결 조항 등
          귀하의 중대한 권익에 관한 굵게 표시된 조항(이에 국한되지 않음)을 유의해 주시기 바랍니다.
        </strong>
      </p>
      <p>
        본 약관의 일부 또는 전부에 동의하지 않으시는 경우, Xiangji 서비스에 등록하거나 로그인 또는 이용하지 마시기
        바랍니다.
      </p>
      <p>
        웹 페이지에서 “동의”, “회원가입”, “로그인”, “시작하기”, “확인” 등의 버튼을 클릭하거나, 실제로 Xiangji 서비스를
        등록, 로그인, 구매 또는 이용하는 경우, 귀하는 본 약관의 전체 내용을 읽고 이해했으며 이에 동의하는 것으로
        간주됩니다.
      </p>
      <p>
        기업, 기관 또는 기타 조직을 대신하여 Xiangji 서비스를 이용하시는 경우, 귀하는 해당 기업, 기관 또는 조직을
        대신하여 본 약관을 수락할 수 있는 적법한 권한을 부여받았으며 해당 주체가 상응하는 책임을 부담한다는 점을
        진술하고 보증합니다.
      </p>
      <section>
        <h2>1. 본 약관의 적용 범위 및 확인</h2>
        <h3>Xiangji 및 제품 서비스</h3>
        <p>
          본 약관에서 “Xiangji” 및 “본 플랫폼”은 苏州象寄科技服务有限公司(쑤저우 샹지 테크놀로지 서비스 유한공사) 및
          그가 운영하는 웹사이트, 웹 애플리케이션, 클라이언트, 브라우저 확장 프로그램과 기타 관련 제품 및 서비스를
          의미합니다.
        </p>
        <p>Xiangji의 공식 웹사이트는 다음과 같습니다:</p>
        <p>
          <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
            <strong>https://www.xiangjifanyi.com/</strong>
          </a>
        </p>
        <p>제공되는 구체적인 서비스는 Xiangji가 실제로 제공하는 제품 기능, 서비스 페이지 및 관련 규칙에 따릅니다.</p>
        <h3>제품 서비스</h3>
        <p>
          “제품 서비스”란 Xiangji가 사용자에게 제공하는 각종 인터넷 및 AI 관련 서비스를 가리키며, 다음을 포함하되 이에
          국한되지 않습니다:
        </p>
        <ul>
          <li>이미지 번역;</li>
          <li>이미지 편집 및 보정;</li>
          <li>이미지 배경 처리;</li>
          <li>상품 이미지 생성;</li>
          <li>상품 장면 이미지 생성;</li>
          <li>상품 모델 이미지 생성;</li>
          <li>상품 대표 이미지 및 보조 이미지 생성;</li>
          <li>상품 상세 이미지 세트 생성;</li>
          <li>상품 상세 페이지, A+ 콘텐츠 등 콘텐츠 생성;</li>
          <li>영상 및 시각 콘텐츠 처리;</li>
          <li>파일 및 PSD 관련 처리;</li>
          <li>API 및 기타 기술 서비스;</li>
          <li>Xiangji가 향후 출시할 기타 관련 서비스.</li>
        </ul>
        <p>
          <strong>
            서비스의 구체적인 내용, 기능, 서비스 기준, 과금 방식 및 이용 규칙은 Xiangji가 실제로 제공하는 서비스와 관련
            페이지의 설명에 따릅니다.
          </strong>
        </p>
        <h3>기타 계약</h3>
        <p>
          본 약관은 Xiangji 개인정보 처리방침, AI 창작 관련 계약, 구독 서비스 구매 계약, API 서비스 계약 및 기타 특정
          서비스 규칙과 함께 Xiangji 서비스 약관 체계를 구성합니다.
        </p>
        <p>
          Xiangji의 특정 서비스를 이용하시는 경우, 해당 서비스에 적용되는 개별 계약 또는 규칙도 함께 준수하셔야 합니다.
        </p>
        <p>개별 계약과 본 약관의 내용이 일치하지 않는 경우, 관련 사항에 대해서는 개별 계약에서 정한 바에 따릅니다.</p>
        <h3>본 약관의 개정</h3>
        <p>
          <strong>
            인터넷 및 인공지능 기술이 빠르게 발전하고 있음을 감안하여, Xiangji는 법령의 변경, 사업 발전, 기술 업그레이드
            및 서비스 조정에 대응하여 본 약관을 개정하거나 보완할 권리를 보유합니다.
          </strong>
        </p>
        <p>
          본 약관에 중대한 변경이 있는 경우, Xiangji는 웹사이트 공지, 제품 페이지, 팝업 창, 제품 내 알림 또는 기타
          합리적인 방식으로 귀하에게 안내합니다.
        </p>
        <p>개정된 약관은 공지일 또는 그에 명시된 발효일부터 효력이 발생합니다.</p>
        <p>
          <strong>
            개정된 약관에 동의하지 않으시는 경우 관련 서비스 이용을 중단하셔야 합니다. 계속하여 Xiangji 서비스에
            접속하거나 이용하시는 경우, 개정된 약관을 수락한 것으로 간주됩니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. 계정 등록 및 보안</h2>
        <h3>계정 등록</h3>
        <p>일부 Xiangji 서비스를 이용하기 전에 Xiangji 계정에 가입하거나 로그인해야 할 수 있습니다.</p>
        <p>
          등록 페이지의 요구에 따라 진실하고 정확하며 완전한 정보를 제공하고, 해당 정보를 적시에 최신 상태로 유지하셔야
          합니다.
        </p>
        <p>
          <strong>
            허위 정보를 제공하거나 타인의 신원 정보를 사칭·도용하는 등 기타 부정한 방식으로 Xiangji 계정을 등록하거나
            사용해서는 안 됩니다.
          </strong>
        </p>
        <h3>계정 보안</h3>
        <p>귀하는 자신의 계정, 비밀번호 및 기타 신원 인증 정보를 적절히 보관할 책임이 있습니다.</p>
        <p>귀하는 자신의 계정을 통해 수행된 모든 조작에 대해 책임을 부담합니다.</p>
        <p>
          귀하 본인의 사유로 인해 계정, 비밀번호, 인증 코드 등의 정보가 유출, 도용되거나 타인에 의해 무단 사용됨으로써
          발생한 손실은 귀하가 부담합니다.
        </p>
        <h3>계정 공유</h3>
        <p>
          Xiangji가 명시적으로 허용하는 기업용 에디션 및 다중 사용자 협업 등의 기능을 제외하고,{' '}
          <strong>
            계정을 임대, 대여, 판매, 양도 또는 공유하는 방식으로 타인에게 계정 사용 권한을 제공해서는 안 됩니다.
          </strong>
        </p>
        <p>
          Xiangji는 계정에 비정상적인 공유, 대량 사용, 악의적인 가입, 비정상적인 API 호출 등 플랫폼 보안에 영향을 미칠
          수 있는 기타 행위가 있음을 발견한 경우, 로그인 제한, 기능 제한, 서비스 일시 중지 또는 계정 종료 등의 조치를
          취할 권리를 보유합니다.
        </p>
        <h3>제3자 계정</h3>
        <p>
          Google, WeChat 또는 기타 제3자 계정을 통해 Xiangji에 로그인하시는 경우, 해당 제3자 플랫폼의 서비스 규칙을
          준수하셔야 합니다.
        </p>
        <p>
          제3자 계정 자체의 사유로 인해 Xiangji 서비스에 로그인하거나 이용할 수 없는 경우, Xiangji는 이로 인해 발생하는
          책임을 부담하지 않습니다.
        </p>
        <h3>계정 해지</h3>
        <p>Xiangji가 제공하는 방식을 통해 계정 해지를 신청할 수 있습니다.</p>
        <p>
          <strong>
            계정이 해지된 후에는, 법령에 별도의 규정이 있거나 당사자 간 별도의 약정이 있는 경우를 제외하고, 해당 계정과
            관련된 서비스 혜택, 미사용 크레딧, 이력 데이터 및 기타 콘텐츠가 Xiangji의 관련 규칙에 따라 삭제되거나 효력을
            상실할 수 있습니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>3. 이용 규칙</h2>
        <p>
          귀하는 Xiangji 서비스를 이용하는 과정에서 중화인민공화국 및 기타 적용 가능한 국가와 지역의 법령, 그리고 사회
          공덕과 공서양속을 준수할 것을 약속합니다.
        </p>
        <p>귀하는 Xiangji 서비스를 이용하여 다음 각 호의 행위를 하여서는 안 됩니다:</p>
        <h3>위법 또는 비준수 콘텐츠</h3>
        <p>다음과 같은 콘텐츠를 제작, 생성, 업로드, 게시, 유포 또는 저장해서는 안 됩니다:</p>
        <ul>
          <li>법령을 위반하는 콘텐츠;</li>
          <li>국가 안보, 공공 안전 또는 사회 안정을 해치는 콘텐츠;</li>
          <li>음란물, 선정성, 폭력, 테러주의 또는 극단주의 콘텐츠;</li>
          <li>사기, 도박, 다단계 판매 등 기타 불법 콘텐츠;</li>
          <li>타인을 모욕, 명예훼손 또는 괴롭히는 콘텐츠;</li>
          <li>기타 법령이 금지하는 콘텐츠.</li>
        </ul>
        <h3>제3자 권리 침해</h3>
        <p>
          Xiangji 서비스를 이용하여 다음을 포함하되 이에 국한되지 않는 제3자의 정당한 권리와 이익을 침해하여서는 안
          됩니다:
        </p>
        <ul>
          <li>저작권;</li>
          <li>상표권;</li>
          <li>특허권;</li>
          <li>초상권;</li>
          <li>프라이버시권;</li>
          <li>명예권;</li>
          <li>영업 비밀;</li>
          <li>기타 정당한 권리와 이익.</li>
        </ul>
        <h3>허위 및 오도성 콘텐츠</h3>
        <p>
          Xiangji 서비스를 이용하여 허위, 기만 또는 소비자를 기만하는 콘텐츠나 타인의 정당한 권리와 이익을 해칠 수 있는
          기타 콘텐츠를 제작하거나 유포해서는 안 됩니다.
        </p>
        <h3>악의적 이용</h3>
        <p>프로그램, 스크립트, 봇, 크롤러 또는 기타 자동화 수단을 이용하여 다음 행위를 하여서는 안 됩니다:</p>
        <ul>
          <li>대량으로 계정을 등록하는 행위;</li>
          <li>악의적으로 서비스를 호출하는 행위;</li>
          <li>이용 제한을 우회하는 행위;</li>
          <li>과금 메커니즘을 해독하거나 회피하는 행위;</li>
          <li>부정한 방식으로 서비스 크레딧을 획득하는 행위;</li>
          <li>플랫폼의 정상 운영을 방해하는 행위;</li>
          <li>플랫폼에 대해 부하 테스트 또는 공격을 수행하는 행위.</li>
        </ul>
        <h3>시스템 및 기술 보호</h3>
        <p>
          <strong>
            Xiangji의 사전 서면 허가 없이, Xiangji의 웹사이트, 소프트웨어, 인터페이스, 서버, 모델 또는 기타 기술
            시스템에 대해 리버스 엔지니어링, 디컴파일, 디스어셈블, 크랙, 복제, 수정 또는 기타 형태의 기술적 분석을
            행하여서는 안 됩니다.
          </strong>
        </p>
        <p>귀하는 다음 행위를 하여서는 안 됩니다:</p>
        <ul>
          <li>플랫폼 프로그램을 크랙하는 행위;</li>
          <li>플랫폼 기능을 수정하거나 변조하는 행위;</li>
          <li>기술적 보호 조치를 우회하는 행위;</li>
          <li>무단으로 서버에 접근하는 행위;</li>
          <li>비공개 데이터를 획득하는 행위;</li>
          <li>플랫폼의 보안 취약점을 탐지하고 공격을 가하는 행위;</li>
          <li>기타 방식으로 플랫폼의 정상 운영을 방해하는 행위.</li>
        </ul>
        <h3>기타 금지 행위</h3>
        <p>법령, 본 약관 또는 Xiangji의 기타 서비스 규칙을 위반하는 기타 행위를 하여서는 안 됩니다.</p>
      </section>
      <section>
        <h2>4. 사용자 업로드 콘텐츠</h2>
        <h3>사용자 콘텐츠</h3>
        <p>
          “사용자 콘텐츠”란 귀하가 Xiangji 서비스를 이용하는 과정에서 업로드, 제출, 입력, 생성, 편집, 저장하거나 기타
          방식으로 Xiangji에 제공하는 텍스트, 이미지, 사진, 영상, 오디오, 상품 정보, 디자인 파일, PSD 파일 및 기타
          콘텐츠를 의미합니다.
        </p>
        <h3>권리 보증</h3>
        <p>
          <strong>
            귀하는 Xiangji에 제공하는 사용자 콘텐츠가 적법한 출처에서 취득된 것이며, 해당 콘텐츠를 이용하는 데 필요한
            모든 권리, 승인 및 라이선스를 취득했음을 보장하셔야 합니다.
          </strong>
        </p>
        <p>
          특히 제3자의 인물 초상, 상품 이미지, 브랜드 상표, 폰트, 음악, 영화·방송 저작물, 디자인 저작물 또는 기타 이와
          유사한 콘텐츠가 관련되는 경우, 필요한 승인을 취득했는지 확인하셔야 합니다.
        </p>
        <h3>사용자 콘텐츠의 권리 귀속</h3>
        <p>
          법령에 별도의 규정이 있거나 당사자 간 별도의 약정이 있는 경우를 제외하고, 적법하게 귀하에게 귀속되는 사용자
          콘텐츠에 대해 귀하가 향유하는 권리는 Xiangji 서비스의 이용으로 인해 변경되지 않습니다.
        </p>
        <p>Xiangji는 본 약관에 근거하여 귀하의 사용자 콘텐츠에 대한 소유권을 무상으로 취득하지 않습니다.</p>
        <h3>서비스에 필요한 라이선스</h3>
        <p>
          귀하에게 서비스를 제공하기 위하여, 귀하는 Xiangji에게{' '}
          <strong>비독점적이며 전 세계를 대상으로 하는 로열티 프리 라이선스</strong>를 부여하는 데 동의합니다. 이를 통해
          Xiangji는 관련 서비스를 제공, 유지, 최적화 및 개선하는 데 필요한 범위에서 귀하의 사용자 콘텐츠를 저장, 복제,
          전송, 처리, 분석 및 기술적으로 가공할 수 있습니다.
        </p>
        <p>본 라이선스는 상기 서비스 목적을 달성하는 데 필요한 기간 동안 유효합니다.</p>
        <h3>콘텐츠 삭제</h3>
        <p>
          Xiangji가 귀하가 업로드하거나 생성한 콘텐츠가 법령, 본 약관 또는 제3자의 정당한 권리와 이익을 위반할 가능성이
          있다고 판단하거나 이에 대한 신고를 접수한 경우, Xiangji는 실제 상황에 따라 해당 콘텐츠를 삭제 또는 차단하거나,
          접근을 제한하거나, 기타 합리적인 조치를 취할 권리를 보유합니다.
        </p>
      </section>
      <section>
        <h2>5. AI 생성 콘텐츠에 관한 특별 조항</h2>
        <p>
          Xiangji의 일부 서비스는 인공지능 모델, 생성형 AI 기술, 머신러닝 알고리즘 및 제3자 AI 인프라를 기반으로
          제공됩니다.
        </p>
        <h3>생성 결과의 내재적 불확실성</h3>
        <p>
          <strong>
            귀하는 AI 생성 결과에는 일정한 불확실성이 내재되어 있으며, Xiangji는 생성 결과가 항상 정확하고, 완전하며,
            진실하고, 적법하고, 귀하의 기대에 부합하거나 제3자의 저작물과 유사하지 않으리라는 점을 보장할 수 없음을
            이해하고 이에 동의합니다.
          </strong>
        </p>
        <p>생성 결과에 다음과 같은 현상이 나타날 수 있습니다:</p>
        <ul>
          <li>입력 내용과 일치하지 않는 이미지 콘텐츠;</li>
          <li>상품 세부 정보의 오류;</li>
          <li>상품 구조 또는 비율의 오류;</li>
          <li>텍스트 인식 또는 번역의 오류;</li>
          <li>인물 또는 장면 생성의 이상;</li>
          <li>사실관계의 오류;</li>
          <li>AI 생성 기술 자체가 지닌 기타 문제.</li>
        </ul>
        <h3>사람에 의한 검토 책임</h3>
        <p>
          <strong>귀하는 AI가 생성, 번역, 편집 또는 처리한 최종 콘텐츠에 대해 사람의 검토를 수행하셔야 합니다.</strong>
        </p>
        <p>
          특히 상품 가격, 치수, 사양, 재질, 기능, 성능, 인증, 효능 등 소비자의 의사 결정에 영향을 미칠 수 있는 정보에
          대해서는 게시, 판매 또는 광고 집행 전에 직접 확인하셔야 합니다.
        </p>
        <p>
          검토 없이 AI 생성 콘텐츠를 바로 사용함으로써 발생한 손실이나 분쟁에 대해서는 귀하가 법에 따라 상응하는 책임을
          부담합니다.
        </p>
        <h3>생성 결과의 고유성 미보장</h3>
        <p>동일하거나 유사한 입력이 동일하거나 상이한 결과를 생성할 수 있습니다.</p>
        <p>
          Xiangji는 AI 생성 결과가 고유하다고 보장하지 않으며, 다른 사용자가 귀하의 것과 유사하거나 동일한 콘텐츠를
          생성하지 않으리라고 보장하지도 않습니다.
        </p>
        <h3>제3자 모델</h3>
        <p>
          Xiangji의 일부 기능은 제3자 AI 모델, 번역 엔진, 클라우드 컴퓨팅 서비스 또는 기타 제3자 기술 서비스를 사용할 수
          있습니다.
        </p>
        <p>
          <strong>
            제3자 모델 또는 서비스의 장애, 업그레이드, 제한, 조정, 일시 중지 또는 종료로 인해 관련 서비스가 영향을 받는
            경우, 법에 별도의 규정이 있는 경우를 제외하고 Xiangji는 합리적인 범위 내에서 대체 또는 복구 조치를 취합니다.
          </strong>
        </p>
        <h3>AI 생성 콘텐츠의 상업적 이용</h3>
        <p>
          사용자는 적용 법령, 제3자 모델의 서비스 약관 및 Xiangji의 구체적인 제품 규칙에 따라 AI 생성 콘텐츠를
          사용하셔야 합니다.
        </p>
        <p>
          <strong>
            상업적 게시, 광고 집행, 상품 판매 등의 시나리오에 사용되는 콘텐츠의 경우, 사용자는 해당 이용의 적법한 근거를
            스스로 확인하고 상업적 이용에 따르는 상응하는 책임을 부담하셔야 합니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>6. 지식재산권</h2>
        <h3>Xiangji의 지식재산권</h3>
        <p>
          <strong>
            Xiangji의 웹사이트, 소프트웨어, 제품, 페이지 디자인, 상표, 로고, 텍스트, 이미지, 프로그램, 알고리즘, 모델,
            데이터베이스, 기술 문서 및 Xiangji가 제공하는 기타 콘텐츠에 대한 지식재산권은 Xiangji 또는 관련 권리
            보유자에게 귀속됩니다.
          </strong>
        </p>
        <p>Xiangji 또는 관련 권리 보유자의 서면 허가 없이 귀하는 다음 행위를 하여서는 안 됩니다:</p>
        <ul>
          <li>복제;</li>
          <li>수정;</li>
          <li>유포;</li>
          <li>판매;</li>
          <li>임대;</li>
          <li>리버스 엔지니어링;</li>
          <li>상업적 이용;</li>
          <li>기타 방식으로 관련 지식재산권을 침해하는 행위.</li>
        </ul>
        <h3>사용자 콘텐츠</h3>
        <p>사용자는 적법하게 자신에게 귀속되는 사용자 콘텐츠에 대해 상응하는 권리를 향유합니다.</p>
        <p>다만 사용자는 Xiangji 서비스의 이용이 제3자의 권리를 침해하지 않도록 보장하셔야 합니다.</p>
        <h3>플랫폼이 생성 및 표시하는 콘텐츠</h3>
        <p>
          Xiangji는 제품 페이지, 도움말 센터, 홍보 자료 또는 기타 맥락에서 샘플 이미지, 템플릿, 폰트, 그래픽, 상표,
          캐릭터 이미지 또는 기타 소재를 표시할 수 있습니다.
        </p>
        <p>
          <strong>Xiangji의 명시적인 승인이 없는 한, 귀하는 상기 콘텐츠를 상업적 목적으로 사용해서는 안 됩니다.</strong>
        </p>
      </section>
      <section>
        <h2>7. 유료 서비스</h2>
        <h3>유료 서비스</h3>
        <p>Xiangji의 일부 제품 및 기능은 유료 서비스입니다.</p>
        <p>
          유료 서비스를 이용하시는 경우, 관련 페이지에 표시된 가격, 과금 방식 및 서비스 규칙에 따라 요금을 지불하셔야
          합니다.
        </p>
        <h3>요금 기준의 조정</h3>
        <p>
          Xiangji는 사업 발전, 기술 비용 및 시장 상황을 고려하여 요금 기준, 플랜 내용, 과금 방식 및 서비스 크레딧을
          조정할 권리를 보유합니다.
        </p>
        <p>
          <strong>
            조정이 귀하가 이미 구매하여 유효 기간 내에 있는 서비스 혜택에 영향을 미치는 경우, Xiangji는 적용 법령 및
            관련 구매 계약에 따라 처리합니다.
          </strong>
        </p>
        <h3>구독 서비스</h3>
        <p>Xiangji 구독 서비스를 구매하시는 경우, 《Xiangji 구독 서비스 구매 계약》도 준수하셔야 합니다.</p>
        <p>구독 서비스의 가격, 기간, 혜택, 환불, 자동 갱신 등 관련 사항은 구독 구매 페이지 및 관련 계약에 따릅니다.</p>
        <h3>무료 서비스</h3>
        <p>Xiangji는 일부 무료 서비스, 체험 크레딧 또는 체험 기능을 제공할 수 있습니다.</p>
        <p>
          <strong>Xiangji는 제품 운영 상황에 따라 무료 서비스를 조정, 일시 중지 또는 중단할 권리를 보유합니다.</strong>
        </p>
      </section>
      <section>
        <h2>8. 서비스의 변경, 중단 및 종료</h2>
        <h3>서비스 업데이트</h3>
        <p>
          사용자 경험을 개선하고 제품 기능을 다듬으며 서비스 보안을 담보하기 위해, Xiangji는 제품을 업데이트,
          업그레이드, 최적화, 조정 또는 이전할 수 있습니다.
        </p>
        <h3>서비스 중단</h3>
        <p>
          다음 사유로 인해 서비스가 일시적으로 중단되거나 정상적으로 이용할 수 없게 된 경우, 이는 Xiangji의 계약
          위반으로 간주되지 않습니다:
        </p>
        <ul>
          <li>시스템 유지 보수 또는 업그레이드;</li>
          <li>네트워크 장애;</li>
          <li>통신사 장애;</li>
          <li>클라우드 서비스 장애;</li>
          <li>제3자 AI 모델 또는 기술 서비스의 장애;</li>
          <li>해킹 공격 또는 사이버 보안 사고;</li>
          <li>불가항력;</li>
          <li>Xiangji의 합리적인 통제 범위를 벗어난 기타 사유.</li>
        </ul>
        <h3>서비스 종료</h3>
        <p>
          다음 각 호의 어느 하나에 해당하는 경우, Xiangji는 귀하에게 제공하는 일부 또는 전체 서비스를 일시 중지하거나
          종료할 권리를 보유합니다:
        </p>
        <ol>
          <li>귀하가 법령을 위반하는 경우;</li>
          <li>귀하가 본 약관 또는 Xiangji의 기타 서비스 규칙을 위반하는 경우;</li>
          <li>귀하가 허위, 잘못되거나 검증할 수 없는 정보를 제공하는 경우;</li>
          <li>관련 주관 당국의 요구가 있는 경우;</li>
          <li>계정, 시스템 또는 거래의 안전을 위한 경우;</li>
          <li>사업, 기술 또는 기타 사유로 서비스 자체를 종료해야 하는 경우;</li>
          <li>Xiangji가 서비스 종료가 필요하다고 판단하는 기타 합리적인 상황.</li>
        </ol>
        <h3>데이터 처리</h3>
        <p>
          서비스가 종료된 후, Xiangji는 법령, 개인정보 처리방침 및 관련 서비스 규칙에 따라 귀하의 데이터를 삭제하거나
          익명화할 수 있습니다.
        </p>
        <p>
          <strong>귀하는 서비스가 종료되기 전에 장기 보관이 필요한 사용자 데이터를 직접 백업하셔야 합니다.</strong>
        </p>
      </section>
      <section>
        <h2>9. 면책 조항 및 책임 제한</h2>
        <h3>불가항력</h3>
        <p>
          법이 허용하는 범위 내에서, 불가항력으로 인해 서비스를 정상적으로 제공할 수 없게 된 경우 Xiangji는 계약 위반에
          대한 책임을 부담하지 않습니다.
        </p>
        <p>불가항력에는 다음이 포함되나 이에 국한되지 않습니다:</p>
        <ul>
          <li>지진;</li>
          <li>태풍;</li>
          <li>홍수;</li>
          <li>화재;</li>
          <li>전쟁;</li>
          <li>정부의 행위;</li>
          <li>중대한 공중보건 사태;</li>
          <li>사이버 공격;</li>
          <li>대규모 네트워크 장애;</li>
          <li>합리적으로 예견, 회피 또는 극복할 수 없는 기타 사건.</li>
        </ul>
        <h3>제3자 서비스</h3>
        <p>
          Xiangji의 일부 서비스는 제3자 네트워크, 결제 서비스, 클라우드 컴퓨팅, AI 모델, 번역 엔진 및 기타 서비스에
          의존합니다.
        </p>
        <p>
          <strong>
            제3자 서비스의 장애, 조정, 제한 또는 종료로 인해 서비스가 중단된 경우, Xiangji는 합리적인 노력을 다해 해결을
            지원하되, Xiangji의 합리적인 통제 범위를 벗어난 손실에 대해서는 책임을 부담하지 않습니다.
          </strong>
        </p>
        <h3>사용자 행위의 위험</h3>
        <p>귀하는 인터넷 및 AI 서비스의 이용에는 일정한 위험이 내재되어 있음을 이해하고 이에 동의합니다.</p>
        <p>
          다른 사용자, 제3자 또는 인터넷 환경으로부터 비롯된 정보, 콘텐츠, 행위 및 위험에 대하여, Xiangji는 법이 정한 바
          이외의 책임을 부담하지 않습니다.
        </p>
        <h3>AI 서비스의 위험</h3>
        <p>
          <strong>
            Xiangji는 AI 생성 콘텐츠가 절대적으로 정확하고, 완전하며, 진실하고, 신뢰할 수 있거나 특정 상업적 목적에
            적합하다는 점을 보장하지 않습니다.
          </strong>
        </p>
        <p>사용자는 실제 이용 시나리오에 비추어 독자적으로 판단하고 검토하셔야 합니다.</p>
        <h3>간접 손실</h3>
        <p>
          법이 허용하는 최대 범위 내에서, Xiangji는 Xiangji 서비스의 이용 또는 이용 불가로 인해 발생한 간접 손실, 이익
          손실, 영업권 손실, 업무 중단 손실 또는 기타 특별 손실에 대해 책임을 부담하지 않습니다.
        </p>
        <p>
          <strong>법률상 Xiangji에게 책임이 요구되는 경우에도, 그 책임의 범위는 법이 정한 바에 따라 제한됩니다.</strong>
        </p>
      </section>
      <section>
        <h2>10. 위반 행위의 처리 및 법적 책임</h2>
        <h3>위반 행위의 처리</h3>
        <p>
          Xiangji가 귀하가 법령, 본 약관 또는 기타 서비스 규칙을 위반하는 행위를 했다고 발견하거나 이에 대한 신고 또는
          민원을 접수한 경우, Xiangji는 실제 상황에 따라 다음 조치를 취할 권리를 보유합니다:
        </p>
        <ul>
          <li>경고;</li>
          <li>관련 콘텐츠의 삭제 또는 차단;</li>
          <li>관련 기능의 제한;</li>
          <li>계정 접근의 제한;</li>
          <li>서비스의 일시 중지;</li>
          <li>계정의 동결;</li>
          <li>계정의 종료;</li>
          <li>기타 합리적인 조치.</li>
        </ul>
        <h3>계정 종료</h3>
        <p>
          <strong>
            귀하의 행위가 법령, 본 약관 또는 기타 플랫폼 규칙을 중대하게 위반하는 경우, Xiangji는 귀하의 계정 및 관련
            서비스를 일시 중지하거나 영구적으로 종료할 권리를 보유합니다.
          </strong>
        </p>
        <p>위반으로 인해 서비스가 종료되는 경우, 계정 내 관련 서비스 혜택을 더 이상 이용하지 못할 수 있습니다.</p>
        <h3>사용자의 배상 책임</h3>
        <p>
          <strong>
            귀하의 위법 또는 비준수 행위, 침해 행위 또는 본 약관 위반으로 인해 Xiangji 또는 그 계열사, 파트너가 제3자의
            청구, 행정 처분, 소송, 중재 또는 기타 손실을 입게 된 경우, 귀하는 법에 따라 상응하는 책임을 부담하며 이로
            인해 Xiangji에 발생한 합리적인 손실을 배상하셔야 합니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>11. 프라이버시 및 개인정보 보호</h2>
        <p>Xiangji는 귀하의 개인정보와 프라이버시 보호를 매우 중요하게 생각합니다.</p>
        <p>
          당사가 귀하의 개인정보를 수집, 이용, 저장, 보호 및 처리하는 방법에 관해서는 Xiangji가 공개하는 개인정보
          처리방침을 참조하시기 바랍니다.
        </p>
        <p>
          <strong>
            귀하는 Xiangji 서비스에 가입, 로그인 또는 이용하기 전에 관련 개인정보 처리방침을 주의 깊게 읽고 이해하셔야
            합니다.
          </strong>
        </p>
        <p>
          특정 서비스가 국경 간 데이터 전송, 제3자 AI 모델 또는 기타 특수한 데이터 처리 시나리오와 관련되는 경우,
          Xiangji는 적용 법령 및 관련 개인정보 처리방침에 따라 해당 데이터를 처리합니다.
        </p>
      </section>
      <section>
        <h2>12. 제3자 서비스 및 링크</h2>
        <p>
          Xiangji의 서비스는 제3자가 제공하는 웹사이트, 소프트웨어, API, 결제 서비스, AI 모델 또는 기타 서비스를
          포함하거나 그에 연결될 수 있습니다.
        </p>
        <p>
          <strong>
            제3자 서비스는 해당 제3자가 독자적으로 제공하며, Xiangji는 법이 정한 범위를 넘어 제3자 서비스의 정확성,
            신뢰성, 적법성 또는 지속적인 가용성에 대해 어떠한 보증도 하지 않습니다.
          </strong>
        </p>
        <p>제3자 서비스를 이용하시는 경우, 해당 제3자의 서비스 약관 및 개인정보 처리방침을 준수하셔야 합니다.</p>
        <p>제3자 서비스의 이용으로 인해 발생한 분쟁은 원칙적으로 귀하와 해당 제3자 간에 해결합니다.</p>
      </section>
      <section>
        <h2>13. 서비스 피드백</h2>
        <p>
          귀하가 Xiangji에 의견, 제안, 제품 피드백 또는 기타 정보를 제공하시는 경우, 법에 따른 귀하의 정당한 권리와
          이익이 침해되지 않는다는 전제 하에, Xiangji가 해당 피드백을 제품 개선, 기술 최적화 및 서비스 운영에 활용하는
          것에 동의하시게 됩니다.
        </p>
        <p>
          당사자 간에 별도의 서면 약정이 없는 한, Xiangji는 귀하의 의견이나 제안을 채택한 대가로 귀하에게 어떠한 비용도
          지급할 의무가 없음을 이해하고 이에 동의합니다.
        </p>
      </section>
      <section>
        <h2>14. 본 약관의 종료</h2>
        <ol>
          <li>
            본 약관은 귀하가 Xiangji 서비스에 가입, 로그인 또는 최초로 이용한 날부터 효력이 발생하며, 귀하가 계정을
            해지하거나 Xiangji가 귀하에 대한 서비스 제공을 중단할 때까지 효력이 유지됩니다.
          </li>
          <li>
            본 약관이 종료된 후에도, 지식재산권, 사용자 책임, 면책 조항, 책임 제한 및 분쟁 해결에 관한 조항을 포함하되
            이에 국한되지 않는 그 성질상 존속되어야 할 조항은 계속 유효합니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>15. 준거법, 관할 및 기타</h2>
        <ol>
          <li>
            <strong>
              본 약관의 체결, 발효, 이행, 해석, 개정, 종료 및 이로 인해 발생한 분쟁의 해결에는 중화인민공화국의 법률이
              적용됩니다.
            </strong>
          </li>
          <li>
            본 약관 또는 Xiangji 서비스의 이용과 관련하여 분쟁이 발생한 경우, 당사자는 우선 우호적인 협의를 통해
            해결하고자 노력합니다.
          </li>
          <li>
            <strong>
              협의가 이루어지지 않는 경우, 어느 일방 당사자든 Xiangji의 실제 운영 주체 소재지를 관할하는 인민 법원에
              소송을 제기할 수 있습니다.
            </strong>
          </li>
          <li>
            본 약관의 어떠한 조항이 관할권을 가진 법원에 의해 무효, 위법 또는 집행 불가능하다고 판단되더라도 나머지
            조항의 효력에는 영향을 미치지 않습니다.
          </li>
          <li>
            본 약관의 제목은 읽기의 편의를 위해 설정된 것으로서, 조항의 해석 또는 법적 효력에 영향을 미치지 않습니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>16. 문의하기</h2>
        <p>
          본 약관, Xiangji의 제품 또는 관련 서비스에 대해 궁금한 점, 의견 또는 불만 사항이 있으시면 다음 채널을 통해
          당사에 문의하실 수 있습니다:
        </p>
        <ul>
          <li>
            공식 웹사이트:{' '}
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>온라인 지원:</strong> Xiangji 제품 내 온라인 고객 지원
          </li>
          <li>
            <strong>지원 이메일:</strong> [공식 지원 이메일 기재 필요]
          </li>
          <li>
            <strong>운영 주체:</strong> [실제 운영 주체의 정식 명칭 기재 필요]
          </li>
          <li>
            <strong>등록 주소:</strong> [등록 주소 기재 필요]
          </li>
        </ul>
        <p>당사는 귀하의 문의 또는 피드백을 접수한 후 합리적인 기간 내에 처리해 드립니다.</p>
      </section>
    </>
  );
};

export default KoContent;
